import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetNegativeWallet(params) {
  return await postRequest("wallet/negative/balance/users", params);
}
export async function serviceExportNegativeWallet(params) {
    return await postRequest('wallet/negative/balance/users/export', params);
}


